import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import { personalDetailsSelectors } from './ducks';
import ShowPersonalDetails from './ShowPersonalDetails';
import EditPersonalInformation from './EditPersonalInformation';
import EditPassword from './EditPassword';
import AddPhoneNumber from './AddPhoneNumber';
import EditDeliveryAddress from './EditDeliveryAddress';
import EditHomeAddress from './EditHomeAddress';
import EditMailingAddress from './EditMailingAddress';
import {
  PERSONAL_DETAILS_PATH,
  EDIT_DELIVERY_ADDRESS_PATH,
  EDIT_PERSONAL_INFORMATION_PATH,
  EDIT_PASSWORD_PATH,
  EDIT_HOME_ADDRESS_PATH,
  EDIT_MAILING_ADDRESS_PATH,
  ADD_PHONE_NUMBER_PATH
} from './routes/routePaths';

const {
  getIsLoadingPersonalDetails,
  getMayEditPersonalDetails,
  getShouldShowHomeAddress,
  getShouldShowMailingAddress,
  getShouldShowDeliveryAddress
} = personalDetailsSelectors;

const Routes = () => {
  const isLoadingPersonalDetails = useSelector(getIsLoadingPersonalDetails);
  const mayEditPersonalDetails = useSelector(getMayEditPersonalDetails);
  const shouldShowHomeAddress = useSelector(getShouldShowHomeAddress);
  const shouldShowMailingAddress = useSelector(getShouldShowMailingAddress);
  const shouldShowDeliveryAddress = useSelector(getShouldShowDeliveryAddress);

  const isEditPersonalDetailsAvailable = mayEditPersonalDetails || isLoadingPersonalDetails;
  const isEditDeliveryAddressAvailable =
    shouldShowDeliveryAddress && isEditPersonalDetailsAvailable;
  const isEditMailingAddressAvailable = shouldShowMailingAddress && isEditPersonalDetailsAvailable;
  const isEditHomeAddressAvailable = shouldShowHomeAddress && isEditPersonalDetailsAvailable;

  const withRedirectToPersonalDetailsGuard =
    (Component: React.ComponentType<any>, shouldShowEditComponent: boolean) =>
    (routeProps: any) => {
      const ComponentToRender = shouldShowEditComponent ? (
        <Component {...routeProps} />
      ) : (
        <Redirect to={PERSONAL_DETAILS_PATH} />
      );
      return ComponentToRender;
    };

  return (
    <Switch>
      <Route exact path={PERSONAL_DETAILS_PATH} component={ShowPersonalDetails} />
      <Route
        exact
        path={EDIT_PERSONAL_INFORMATION_PATH}
        render={withRedirectToPersonalDetailsGuard(
          EditPersonalInformation,
          isEditPersonalDetailsAvailable
        )}
      />
      <Route exact path={ADD_PHONE_NUMBER_PATH} component={AddPhoneNumber} />
      <Route exact path={EDIT_PASSWORD_PATH} component={EditPassword} />
      <Route
        exact
        path={EDIT_DELIVERY_ADDRESS_PATH}
        render={withRedirectToPersonalDetailsGuard(
          EditDeliveryAddress,
          isEditDeliveryAddressAvailable
        )}
      />
      <Route
        exact
        path={EDIT_HOME_ADDRESS_PATH}
        render={withRedirectToPersonalDetailsGuard(EditHomeAddress, isEditHomeAddressAvailable)}
      />
      <Route
        exact
        path={EDIT_MAILING_ADDRESS_PATH}
        render={withRedirectToPersonalDetailsGuard(
          EditMailingAddress,
          isEditMailingAddressAvailable
        )}
      />
      <Redirect to={PERSONAL_DETAILS_PATH} />
    </Switch>
  );
};

export default Routes;
